/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * Your Project
 * API for all things …
 * OpenAPI spec version: 1.0.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  Employee
} from '../../schema'


/**
 * List all employees
 */
export const listEmployees = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Employee[]>> => {
    return axios.get(
      `/employees/`,options
    );
  }


export const getListEmployeesQueryKey = () => [`/employees/`];

    
export type ListEmployeesQueryResult = NonNullable<Awaited<ReturnType<typeof listEmployees>>>
export type ListEmployeesQueryError = AxiosError<unknown>

export const useListEmployees = <TData = Awaited<ReturnType<typeof listEmployees>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEmployees>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListEmployeesQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listEmployees>>> = ({ signal }) => listEmployees({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof listEmployees>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Create employee
 */
export const createEmployee = (
    employee: Employee, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Employee>> => {
    return axios.post(
      `/employees/`,
      employee,options
    );
  }



    export type CreateEmployeeMutationResult = NonNullable<Awaited<ReturnType<typeof createEmployee>>>
    export type CreateEmployeeMutationBody = Employee
    export type CreateEmployeeMutationError = AxiosError<unknown>

    export const useCreateEmployee = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployee>>, TError,{data: Employee}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEmployee>>, {data: Employee}> = (props) => {
          const {data} = props ?? {};

          return  createEmployee(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof createEmployee>>, TError, {data: Employee}, TContext>(mutationFn, mutationOptions)
    }
    